/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AffectedProjectOnUmbrellaChangeResource
 */
export interface AffectedProjectOnUmbrellaChangeResource {
    /**
     * 
     * @type {string}
     * @memberof AffectedProjectOnUmbrellaChangeResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AffectedProjectOnUmbrellaChangeResource
     */
    subject: string;
    /**
     * 
     * @type {number}
     * @memberof AffectedProjectOnUmbrellaChangeResource
     */
    firstAffectedMonth?: number;
}

/**
 * Check if a given object implements the AffectedProjectOnUmbrellaChangeResource interface.
 */
export function instanceOfAffectedProjectOnUmbrellaChangeResource(value: object): value is AffectedProjectOnUmbrellaChangeResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    return true;
}

export function AffectedProjectOnUmbrellaChangeResourceFromJSON(json: any): AffectedProjectOnUmbrellaChangeResource {
    return AffectedProjectOnUmbrellaChangeResourceFromJSONTyped(json, false);
}

export function AffectedProjectOnUmbrellaChangeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffectedProjectOnUmbrellaChangeResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'subject': json['subject'],
        'firstAffectedMonth': json['firstAffectedMonth'] == null ? undefined : json['firstAffectedMonth'],
    };
}

export function AffectedProjectOnUmbrellaChangeResourceToJSON(value?: AffectedProjectOnUmbrellaChangeResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'subject': value['subject'],
        'firstAffectedMonth': value['firstAffectedMonth'],
    };
}

